import React, { ReactElement } from 'react'

import CookiePolicy from '../components/terms/CookiePolicy'
import { CompanyReducer } from '../reducers/companies'
import { connectToReducer } from '../utils/reducer-utils'

type Reducers = {
  companies: CompanyReducer
}

function CookiePolicyContainer(props: Reducers): ReactElement | null {
  return <CookiePolicy company={props.companies.company} />
}

export default connectToReducer<Reducers, any>(
  (state) => ({
    companies: state.companies,
  }),
  {}
)(CookiePolicyContainer)
